import { IArchiveConfig } from "@core/services/interfaces/geral/archive/IArchiveService";

const archiveConfig: IArchiveConfig = {
  // Endpoints
  getArchiveValueEndpoint: "/api/Geral/GerenciadorArquivo",
  deleteArchiveValueEndpoint: "/api/Geral/GerenciadorArquivo/RemoverArquivo",
};

export default archiveConfig;
